<div style="display: flex;flex-flow: column;height: 100%;gap: 30px;" class="flex flex-col h-full">
  <!-- <app-head-o2 style="width: 100%;" [type]="'ms24'"></app-head-o2> -->
  <div class="flex flex-col pl-10 pr-10 pt-10">
    <div class="menu">
      <div style="display: flex;flex-flow: row;gap: 10px;align-items: stretch;">
        <!-- Mockup TypeUser Surveyor  -->
        <!-- <button class="set-btn-unlimited" mat-raised-button color="accent" (click)="createMs24($event)">
          สร้างใบ มส.24
        </button> -->
        <button mat-raised-button style="width: 70px;font-size: 1.5em;" matTooltip="รีเฟรชข้อมูล" matTooltipPosition="above" (click)="onRefresh()">
          <i class="ti ti-refresh"></i>
        </button>
      </div>
      <div style="display: flex;flex-flow: row;gap: 10px;flex: 1;justify-content: flex-end;">
        <div class="mat-button" style="gap: 10px;flex: 0 40%;">
          <!-- <h4>records</h4> -->
          <mat-form-field style="display: flex;flex-flow: row;flex: 1" class="my-form-field">
            <input autocomplete="off" type="text" matInput placeholder="เลขที่ใบรับรอง / รายละเอียดคำร้อง" matInput
              #input [(ngModel)]="searchString" name="searchText" #search="ngModel"
              (keyup)="applyFilter($event.target.value)">
            <button matSuffix mat-icon-button aria-label="ค้นหา">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <button mat-raised-button color="accent" [matMenuTriggerFor]="myMenu" (menuClosed)="menuClosed()">
          <div class="flex items-center">
            <span>เงื่อนไขการค้นหา</span>
            <mat-icon>expand_more</mat-icon>
          </div>
        </button>
        <mat-menu #myMenu="matMenu" xPosition="before" class="my-menu">
          <div class="pl-2 pr-2" (click)="stopPropagation($event)">
            <div class="pl-2 pr-2">
              <div class="flex flex-row">
                <div class="basis-full">
                  <mat-form-field class="my-form-field formm w100">
                    <mat-label>เลขที่ใบรับรอง</mat-label>
                    <input autocomplete="off" type="text" matInput placeholder="คำค้นหา" #input
                      [(ngModel)]="searchForm.refNo" name="refNo" #refNo="ngModel">
                  </mat-form-field>
                </div>
              </div>
              <div class="flex flex-row">
                <div class="basis-full">
                  <mat-form-field class="my-form-field formm w100">
                    <mat-label>รายละเอียดคำร้อง</mat-label>
                    <input autocomplete="off" type="text" matInput placeholder="คำค้นหา" #input
                      [(ngModel)]="searchForm.description" name="description" #description="ngModel">
                  </mat-form-field>
                </div>
              </div>
              <div class="flex flex-row">
                <div class="basis-full">
                  <mat-form-field class="my-form-field formm w100" (click)="exDate.open()">
                    <mat-label>วันที่ยื่นคำร้อง</mat-label>
                    <input autocomplete="off" placeholder="วันที่ยื่นคำร้อง" matInput [matDatepicker]="exDate"
                      [(ngModel)]="searchForm.requestDate" name="requestDate" #requestDate="ngModel">
                    <mat-datepicker-toggle matSuffix [for]="exDate"></mat-datepicker-toggle>
                    <mat-datepicker #exDate></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div class="flex flex-row">
                <div class="basis-full">
                  <mat-form-field class="my-form-field formm w100">
                    <mat-label>สถานะ</mat-label>
                    <mat-select [(ngModel)]="searchForm.statusId" name="statusId" #statusId="ngModel" ngmodel>
                      <mat-option *ngFor="let status of statusList" [value]="status.statusId">
                        {{status.statusName}}
                      </mat-option>
                    </mat-select>
                    <mat-error>สถานะ</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="flex justify-end formm">
                <div class="flex flex-row">
                  <button mat-raised-button (click)="clearOption()" style="flex:0 50%; margin-right: 10px;">
                    เคลียร์
                  </button>
                  <button mat-raised-button color="accent" (click)="searchOption()" style="flex:0 50%;">
                    ค้นหา
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>
      </div>
    </div>
  </div>
  <div class="mat-elevation-z8">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    <table mat-table matSort style="width: 100%;" [dataSource]="dataSource"
      (matSortChange)="announceSortChange($event)">
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ลำดับ </th>
        <td mat-cell *matCellDef="let i = index">
          {{this.paginator.pageIndex == 0 ? i + 1 : 1 + i + this.paginator.pageIndex * this.paginator.pageSize}}
        </td>
      </ng-container>
      <ng-container matColumnDef="refNo">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center;">เลขที่ใบรับรอง</th>
        <td mat-cell *matCellDef="let element"> {{element.refNo}} </td>
      </ng-container>
      <ng-container matColumnDef="requestDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center;">วันที่ยื่นคำร้อง</th>
        <td mat-cell *matCellDef="let element"> {{(element.requestDate | date:'yyyy-MM-dd') || '-'}}
          {{(element.requestDate | date:'HH:mm')}} </td>
      </ng-container>
      <ng-container matColumnDef="exporterName">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center;">ผู้ส่งออก</th>
        <td mat-cell *matCellDef="let element"> {{element.exporterName || '-'}} </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center;">รายการ</th>
        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
      </ng-container>
      <ng-container matColumnDef="statusCode">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center;">สถานะ</th>
        <td mat-cell *matCellDef="let element"> {{element.statusCode}} </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Action </th>
        <td mat-cell *matCellDef="let element;let i = index">
          <!-- <button mat-icon-button matTooltip="รายละเอียด" matTooltipPosition="above">
            <i class="ti ti-file-description"></i>
          </button>
          <button mat-icon-button matTooltip="แก้ไขและยื่นคำร้องใหม่" matTooltipPosition="above">
            <i class="ti ti-edit"></i>
          </button> -->
          <button mat-icon-button matTooltip="อนุมัติ" (click)="updateStatusApprove(element, 9)"
            matTooltipPosition="above" *ngIf="element.status === 2 && checkButton('BT139')" >
            <i class="ti ti-check" style="color: green"></i>
          </button>
          <button mat-icon-button matTooltip="ไม่อนุมัติ" (click)="updateStatusApprove(element, 4)"
            matTooltipPosition="above" *ngIf="element.status === 2 && checkButton('BT140')">
            <i class="ti ti-x" style="color: red"></i>
          </button>
          <button mat-icon-button matTooltip="ถอนคำร้อง" (click)="updateStatusApprove(element, 1)" matTooltipPosition="above" *ngIf="element.status === 2 && checkButton('BT141')">
            <i class="ti ti-transfer-out"></i>
          </button>
          <button mat-icon-button matTooltip="ยื่นคำร้องใหม่" (click)="updateStatusApprove(element, 2)" matTooltipPosition="above" *ngIf="element.status === 1 && checkButton('BT142')">
            <i class="ti ti-transfer-in"></i>
          </button>
          <button mat-icon-button matTooltip="ลบ" (click)="deleteItem(element)" matTooltipPosition="above" *ngIf="element.status === 1 && checkButton('BT144')">
            <i class="ti ti-trash"></i>
          </button>
          <!-- <button mat-icon-button matTooltip="พิมพ์เอกสาร" (click)="printItem(element)" matTooltipPosition="above" *ngIf="element.status === 9 && checkButton('BT143')">
            <i class="ti ti-printer"></i>
          </button> -->

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 50, 100]" (page)="_page($event)" showFirstLastButtons
      aria-label="Select page of periodic elements">
    </mat-paginator>
  </div>
</div>